<template>
    <div>
        <div v-if="!loading">
            <component :is="currentFormComponent" v-if="form_name" :initialData="formInitialData"/>
        </div>
        <div v-else>
            <div class="dotted-loader">
            </div>
            <div class="h-80"></div>
        </div>
    </div>
    </template>
    
    <script>
    //forms
    import AntiAging from '@/components/forms/AntiAgingForm.vue';
    import MethyleBlue from '@/components/forms/MethyleBlueForm.vue';
    import VitaminB12 from '@/components/forms/VitaminB12Form.vue';
    import CopperPeptide from '@/components/forms/CopperPeptideForm.vue';
    import Sermorelin from '@/components/forms/SermorelinForm.vue';
    import FullMedicalForm from '@/components/forms/FullMedicalForm.vue';
    import BalugaWeightLoss from '@/components/forms/QuestionsStepsLoader.vue';
    import EDForm from '@/components/forms/EDForm.vue';
    import HairLoss from '@/components/forms/HairLoss.vue';
    import pt141Form from '@/components/forms/pt141Form.vue';
    import { getProductById } from '@/utils/productData'
    import { mapGetters } from 'vuex';
    export default {
        name: 'FormLoader',  // Changed from FullMedicalForm to match component's purpose
        components: {
            AntiAging,
            MethyleBlue,
            VitaminB12,
            CopperPeptide,
            Sermorelin,
            EDForm,
            HairLoss,
            pt141Form,
            FullMedicalForm,
            BalugaWeightLoss
        },
        data() {
            return {
                loading: true,
                form_name: null
            }
        },
        computed: {
            ...mapGetters(['user']),
            formInitialData(){
                if (!this.user) return null;
                const totalInches = parseInt(this.user.height_inch || 0);
                const feet = Math.floor(totalInches / 12);
                const inches = totalInches % 12;
                const formattedHeight = totalInches ? `${feet}'${inches}"` : null;
                return {
                    gender: this.user.gender,
                    height: formattedHeight,  // or could be separate fields for feet and inches
                    weight: this.user.weight
                }
            },
            currentFormComponent() {
                const formMap = {
                    'AntiAging': 'AntiAging',
                    'MethyleBlueForm': 'MethyleBlue',
                    'VitaminB12Form': 'VitaminB12',
                    'CopperPeptideForm': 'CopperPeptide',
                    'SermorelinForm': 'Sermorelin',
                    'EDForm': 'EDForm',
                    'HairLoss': 'HairLoss',
                    'PT141': 'pt141Form',
                    'WeightLossOpen': 'FullMedicalForm',
                    'WeightLoss': 'BalugaWeightLoss'
                }
                return this.form_name ? formMap[this.form_name] : null
            }
        },
        created() {  // Changed from mounted to created
            this.getOrder()
        },
        methods: {
            async getOrder() {
                try {
                    console.log("getting order details")
                    const response = await this.$axios.get(`${process.env.VUE_APP_API_ENDPOINT}/forms/orders/${this.$route.params.id}`);
                    
                    if (response.data.status === 'success' && response.data.order.status === 'pending_approval') {
                        const product = getProductById(response.data.order.product_id)[0];
                        
                        /*this.form_name = (product.form_name === 'WeightLoss' && 
                            ['Tirzepatide', 'Semaglutide'].includes(product.name)) 
                            ? 'WeightLossOpen' 
                            : product.form_name;*/
                        this.form_name = product.form_name;
                        this.loading = false;
                        window.scrollTo(0, 0);
                    } else {
                        this.$router.push('/sorry?message=Order not found or the assessment form was already submitted. Login to your dashboard to see details.')
                    }
                } catch (error) {
                    console.error('Error fetching order:', error);
                    this.$router.push('/sorry?message=An error occurred while fetching your order. Please try again later.')
                }
            }
        },
    }
    </script>
    
    <style scoped>
    
    .dotted-loader {
        position: relative;
        text-align: center;
        margin-top: 100px;
    }
    .dotted-loader::after ,
    .dotted-loader::before {
        content: "";
        position: absolute;
        width: 100px;
        height: 100px;
        border-radius: 50%;
        border: 4px #e9ff86;
        border-style: dotted solid dotted solid;
        animation: turn-left 1.5s linear infinite;
    }
    .dotted-loader::before {
        left: calc(50% - 25px);
        top: calc(50% - 25px);
        width: 150px;
        height: 150px;
        border-style: dotted dotted solid solid;
        animation: turn-right 1.5s linear infinite;
    }
    @keyframes turn-right {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
    @keyframes turn-left {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(-360deg);
        }
    }
    </style>